import React from 'react';
import { Button, useBreakpoint } from '@landr/maestro';
import { useAuthentication } from 'components/Authentication';

export const SignUpOrGoToApp: React.FC<{ label: string; goToAppLabel: string }> = ({ label, goToAppLabel }) => {
    const { isAuthenticated, signupUrl } = useAuthentication();
    const isMobile = useBreakpoint('lg');

    return (
        <Button
            as="a"
            variant="secondary"
            size={isMobile ? 'sm' : 'md'}
            href={isAuthenticated ? process.env.GATSBY_APP_ENDPOINT : signupUrl}
            isRounded
        >
            {isAuthenticated ? goToAppLabel : label}
        </Button>
    );
};
